import { LayoutPageTitle } from '@/features/layout';
import { UploadsPage } from '@/features/uploads';
import styles from './Uploads.module.css';

export default function Uploads() {
  return (
    <>
      <LayoutPageTitle title="Uploads" />
      <main className={styles.content}>
        <UploadsPage />
      </main>
    </>
  );
}
